import React from 'react';
import { Button } from 'react-admin';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import IconCancel from '@material-ui/icons/Cancel';

import IntegrationModal from './IntegrationModal';

const MoreInfoModal = ({ integration, closeModal }) => {
  const { name, more_info } = integration;

  return (
    <IntegrationModal closeModal={closeModal}>
      <DialogTitle>{name}</DialogTitle>
      <DialogContent style={{ maxWidth: '300px' }}>
        <div>{more_info}</div>
      </DialogContent>
      <DialogActions>
        <Button label="ra.action.close" onClick={closeModal}>
          <IconCancel />
        </Button>
      </DialogActions>
    </IntegrationModal>
  );
};

export default MoreInfoModal;
